import * as React from "react";
import { Box, IconButton, Typography, Stack } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { darkColors } from "../../theme/colors";
import { assetIcons } from "../../constants/assets";
import { fontSizes } from "../../theme/font-sizes";
import routes from "../../constants/routes";
import InlineSvg from "../utils/inline-svg";

const menuItems = [
  {
    text: "Live Games",
    icon: assetIcons.streamSidebar,
    path: routes.live_games,
  },
  {
    text: "Home",
    icon: assetIcons.homeSidebar,
    path: routes.home,
  },
  {
    text: "Community",
    icon: assetIcons.communitySidebar,
    path: routes.community,
  },
];

export default function MobileBar({ handleOpen }) {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => {
    if (path === "/") {
      return location.pathname === "/";
    }
    return location.pathname.startsWith(path);
  };

  const handleItemClick = (path) => {
    if (
      location.pathname === "/race" &&
      (path === "/home" || path === "/live-games" || path === "/community")
    ) {
      // If on Race page and navigating to Home, show confirmation modal
      handleOpen(path); // Open the modal
    } else {
      // Navigate directly for other cases
      navigate(path);
    }
  };

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        height: "100px",
        backgroundColor: darkColors.backgroundBottom,
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        boxShadow: "0 -2px 5px rgba(0,0,0,0.3)",
      }}
    >
      {menuItems.map((item) => (
        <IconButton
          key={item.text}
          onClick={() => handleItemClick(item.path)}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            color: isActive(item.path)
              ? darkColors.primary
              : darkColors.sidebarGray,
          }}
        >
          <Stack alignItems="center" spacing={2}>
            <InlineSvg
              sx={{ height: "20px", width: "20px" }}
              color={
                isActive(item.path)
                  ? darkColors.primary
                  : darkColors.sidebarGray
              }
              url={item.icon}
            />
            <Typography
              sx={{
                fontSize: fontSizes.heading3,
                fontFamily: isActive(item.path)
                  ? "MontserratBold"
                  : "Montserrat",
              }}
            >
              {item.text}
            </Typography>
          </Stack>
        </IconButton>
      ))}
    </Box>
  );
}
